module.exports = __webpack_public_path__ + "60be8975b6a044017c38156e25090561.pdf";